import type { StoreApi } from './types';

export const UnarchiveIssueModalActions = {
	openUnarchiveIssueModal:
		(issueKey: string) =>
		({ setState }: StoreApi) => {
			setState({ isUnarchiveIssueModalOpen: true, issueKey });
		},
	closeUnarchiveIssueModal:
		() =>
		({ setState }: StoreApi) => {
			setState({ isUnarchiveIssueModalOpen: false, issueKey: null });
		},
};

export type Actions = typeof UnarchiveIssueModalActions;
